import React, { useEffect, useRef, useState } from "react";
import "./overview/overview.css";
import {
  MenuItem,
  Select,
  Button,
  Checkbox,
  ListItemText,
  Tooltip,
} from "@mui/material";
import CustomDateModal from "./customeDateModal";
import { colorBrandObject } from "../../../constants/brandings";

export default function DownloadAndDropdown({
  showDropdown,
  showDownloadIcon,
  handleDropdownChange,
  showRefreshIcon,
  handleRefreshChange,
  showBusinessUnit,
  handleBussinessUnitChange,
  handleCurrencyFilterChange,
  showCurrency,
  currency,
  configPaymentData,
  setLoading,
  handleSingleStartDate,
  singleStartDateValue,
  handleStartDate,
  handleEndDate,
  startDateValue,
  endDateValue
}) {
  const [dropdownContent, setDropdownContent] = useState("");
  const [previousDropdownContent, setPreviousDropdownContent] = useState("");
  const [selectedBusinessUnits, setSelectedBusinessUnits] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [dateModalOpen, setDateModalOpen] = useState(false);
  const hasOpenedModal = useRef(false);
  const [currencyDefaultValue, setCurrencyDefaultValue] = useState(localStorage.getItem("selectedFilterCurrency") || "");
  const [initialSelectedBusinessUnits, setInitialSelectedBusinessUnits] = useState([]);
  const [radioButton, setRadioButton] = useState("singleDate");

  const handleChange = (event) => {
    const value = event.target.value;
    setPreviousDropdownContent(dropdownContent); // Store the current value before changing it

    setDropdownContent(value);
    handleDropdownChange(value);
    if (value === "customDate") {
      setDateModalOpen(true);
    }
    handleSingleStartDate("");
    hasOpenedModal.current = value === "customDate";
    localStorage.removeItem("selectStartDate");
    localStorage.removeItem("selectEndDate");
    localStorage.removeItem("selectSingleDate");
    localStorage.removeItem("dateRadio");
  };

  const handleSelectClick = (event) => {
    const value = event.target.getAttribute("data-value");
    if (value === "customDate" && dropdownContent === "customDate") {
      setDropdownContent("");
      setTimeout(() => {
        setDropdownContent("customDate");
        handleDropdownChange("customDate");
        setDateModalOpen(true);
        // handleSingleStartDate("");
        hasOpenedModal.current = true;
      }, 0);
    }
  };

  useEffect(() => {
    const storedDropdown = localStorage.getItem("selectedDropdownValue");
    if (storedDropdown) {
      setDropdownContent(storedDropdown);
      setLoading(true);
    } else {
      setDropdownContent("today");
    }
  }, []);

  useEffect(() => {
    if (configPaymentData && Array.isArray(configPaymentData)) {
      const allCodes = configPaymentData.map((item) => item.code);
      setInitialSelectedBusinessUnits(allCodes);
    }
  }, [configPaymentData]);

  const handleBusinessChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedBusinessUnits(
      typeof value === "string" ? value.split(",") : value
    );
    setLoading(true);
    localStorage.setItem("selectedBusinessUnit", value);
  };

  useEffect(() => {
    const storedSelectedBusinessUnits = localStorage.getItem(
      "selectedBusinessUnit"
    );
    if (storedSelectedBusinessUnits) {
      setSelectedBusinessUnits(storedSelectedBusinessUnits.split(","));
    }
  }, []);

  const handleRefreshButton = () => {
    setRefresh(!refresh);
    handleRefreshChange(!refresh);
    setLoading(true);
  };

  useEffect(() => {
    if (selectedBusinessUnits?.length > 0) {
      handleBussinessUnitChange(selectedBusinessUnits);
    } else {
      handleBussinessUnitChange(initialSelectedBusinessUnits);
    }
  }, [selectedBusinessUnits, initialSelectedBusinessUnits]);

  useEffect(() => {
    const storedCurrency = localStorage.getItem("selectedFilterCurrency");
    if (storedCurrency) {
      const currencyExistsInOptions = currency.some(
        (option) => option?.value === storedCurrency
      );
      if (currencyExistsInOptions) {
        setCurrencyDefaultValue(storedCurrency);
      } else if (currency && currency?.length > 0) {
        setCurrencyDefaultValue(currency[0]?.value);
      }
    } else if (currency && currency?.length > 0) {
      setCurrencyDefaultValue(currency[0]?.value);
    }
  }, [currency]);

  useEffect(() => {
    if (currencyDefaultValue) {
      handleCurrencyFilterChange(currencyDefaultValue);
      setLoading(true);
    }
  }, [currencyDefaultValue]);

  useEffect(() => {
    if (dropdownContent === "customDate" || hasOpenedModal.current) {
      // setDateModalOpen(true);
    }
  }, [dropdownContent, hasOpenedModal]);

  const handleCloseDateModal = () => {
    setDateModalOpen(false);
    hasOpenedModal.current = false; // Reset to false when modal is closed
  };

  return (
    <div className="dropdownDiv">
      {showRefreshIcon && (
        <Button className="refreshButton" onClick={() => handleRefreshButton()}>
          Refresh
          <img
            src="/assets/refresh.svg"
            alt="refresh"
            style={{ marginLeft: "4px" }}
          />
        </Button>
      )}

      {showBusinessUnit && (
        <div>
          <Select
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            multiple
            style={{
              fontFamily: "Poppins",
              fontSize: "14px",
              fontWeight: 400,
              height: "32px",
              width: "200px",
              marginRight: "12px",
              color: "var(--character-title-85, rgba(0, 0, 0, 0.85))",
            }}
            value={selectedBusinessUnits}
            onChange={handleBusinessChange}
            classes={{ icon: "custom-dropdown-icon" }}
            renderValue={(selected) => (
              <div className="itemNameStyling">
                {selected.length > 0
                  ? selected
                    .map(
                      (value) =>
                        configPaymentData.find((item) => item.code === value)
                          ?.name
                    )
                    .join(", ")
                  : "Business Units"}
              </div>
            )}
            displayEmpty
          >
            {configPaymentData?.map((item) => (
              <MenuItem
                key={item?.code}
                value={item?.code}
                className="businessUnit businessUnitCheckbox"
                style={{ padding: "5px 10px", height: "40px" }}
              >
                <Checkbox
                  sx={{
                    '& .MuiSvgIcon-root': {
                      color: colorBrandObject?.secondaryButtonColor,
                    },
                    '&.Mui-checked': {
                      color: colorBrandObject?.secondaryButtonColor,
                      '& .MuiSvgIcon-root': {
                        fill: colorBrandObject?.secondaryButtonColor,
                      },
                    },
                  }}
                  checked={selectedBusinessUnits.indexOf(item?.code) > -1}
                />
                <div
                  className="ellipsisListItem"
                  style={{
                    paddingLeft: "6px",
                  }}
                >
                  {item?.name?.length > 12 ? (
                    <Tooltip title={item?.name}>
                      <ListItemText primary={item?.name} />
                    </Tooltip>
                  ) : (
                    <ListItemText primary={item?.name} />
                  )}
                </div>
              </MenuItem>
            ))}
          </Select>
        </div>
      )}

      {showCurrency && (
        <div>
          <Select
            style={{
              fontFamily: "Poppins",
              fontSize: "14px",
              fontWeight: 400,
              height: "32px",
              width: "90px",
              marginRight: "12px",
              color: "var(--character-title-85, rgba(0, 0, 0, 0.85))",
            }}
            value={currencyDefaultValue}
            onChange={(e) => setCurrencyDefaultValue(e.target.value)}
            classes={{ icon: "custom-dropdown-icon" }}
            renderValue={(selected) => selected || currencyDefaultValue}
            displayEmpty
          >
            {currency.length > 0 &&
              currency?.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  <div>{option.value}</div>
                </MenuItem>
              ))}
          </Select>
        </div>
      )}

      {showDropdown && (
        <div>
          <Select
            className="monthDropdown dropdown"
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={dropdownContent}
            onChange={(e) => handleChange(e)}
            onClick={handleSelectClick}
            style={{
              fontFamily: "Poppins",
              fontSize: "14px",
              fontWeight: 400,
              height: "32px",
              color: "var(--character-title-85, rgba(0, 0, 0, 0.85))",
              width: "140px",
            }}
            classes={{ icon: "custom-dropdown-icon" }}
          >
            <MenuItem value="today">Today</MenuItem>
            <MenuItem value="yesterday">Yesterday</MenuItem>
            <MenuItem value="lastWeek">Last 7 days</MenuItem>
            <MenuItem value="thisMonth">Last 30 days</MenuItem>
            {/* <MenuItem value="thisWeek">This Week</MenuItem> */}
            <MenuItem value="last3Months">Last 3 Months</MenuItem>
            <MenuItem value="last6Months">Last 6 Months</MenuItem>
            <MenuItem value="last12Months">Last 12 Months</MenuItem>
            <MenuItem value="thisLastMonth">This Month</MenuItem>
            <MenuItem value="thisYear">This Year</MenuItem>
            <MenuItem value="customDate">Custom Date</MenuItem>
          </Select>
        </div>
      )}

      {showDownloadIcon && (
        <div className="downloadIconPosition">
          <img
            src="/assets/download.svg"
            alt="download"
            style={{
              height: "34px",
              width: "34px",
              marginLeft: "11px",
              marginRight: "11px",
            }}
          />
        </div>
      )}

      {dropdownContent === "customDate" && (
        <CustomDateModal
          openModal={dateModalOpen}
          onClose={handleCloseDateModal}
          handleṢingleStartDate={handleSingleStartDate}
          singleStartDateValue={singleStartDateValue}
          handleStartDate={handleStartDate}
          handleEndDate={handleEndDate}
          previousDropdownContent={previousDropdownContent}
          setDropdownContent={setDropdownContent}
          handleDropdownChange={handleDropdownChange}
          radioButton={radioButton}
          setRadioButton={setRadioButton}
          startDateValue={startDateValue}
          endDateValue={endDateValue}
        />
      )}
    </div>
  );
}
